import { HistoryMessageSegment } from "types/historyMessageTypes";

/**
 * Builds formatted message for USER history type
 * Add implementation when product owner defines format
 */
export class UserMessageBuilder {
  static build(user: any): HistoryMessageSegment[] {
    // TODO: Define format for USER type
    return [];
  }
}
